<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요.
  - 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다
  - 해당 팝업은 MO에서는 풀로 나오는 형태라 type-mo-full 클래스 추가해주셔야합니다.
-->
  <AbstractPop :type-mo-full="true">
    <div class="dialog type-filter">
      <header class="dialog-header">
        <h2>
          <span class="sr-only">상세조회 팝업</span>
        </h2>
        <button
          type="button"
          class="dialog-close"
          data-popup-close
          @click="() => emit('close')"
        >
          <span class="c-icon icon-large-x"></span>
          <span class="sr-only">팝업 닫기</span>
        </button>
      </header>

      <div class="dialog-content">
        <div class="dialog-content-inner">
          <!-- D: MO에서만 존재 -->
          <h3 class="c-title-level3 only-mo">상세 조회</h3>
          <!-- 모바일 영역 -->
          <div class="c-search only-mo">
            <h2 class="sr-only">검색 영역</h2>
            <form class="search-form" @submit.prevent="btnCmd('biz1#search')">
              <label class="sr-only">제품검색</label>
              <!-- D: MO에서는 input readonly 추가 필요합니다(레이어팝업 오픈하기 위함) -->
              <input
                type="text"
                id="searchQuery"
                title="검색"
                class="search-input"
                autocomplete="off"
                :placeholder="'제품명/제품코드 입력'"
                v-model="data.biz1.search.searchQuery"
              />
              <button
                type="button"
                class="search-cancel"
                @click="data.biz1.search.searchQuery = ''"
              >
                <i class="c-icon icon-large-x"></i>
                <span class="sr-only">검색어 재입력</span>
              </button>
              <button type="submit" class="search-submit">
                <span class="sr-only">검색</span>
              </button>
            </form>
          </div>
          <!-- // 모바일 영역 -->
          <div class="mo-detail-search-wrap">
            <div class="detail-search-box">
              <section class="item-box">
                <h3 class="c-title-level4">조회 기간</h3>
                <ul class="c-check-field col2">
                  <li>
                    <div class="c-radio">
                      <input
                        type="radio"
                        id="raido1-0"
                        name="raidogroup"
                        value="all"
                        :checked="calSelected"
                      />
                      <label for="raido1-0">기간선택</label>
                    </div>
                    <!-- D : 달력 -->
                    <div class="c-form-field">
                      <label class="c-input-calender">
                        <input
                          type="text"
                          title="시작일"
                          readonly
                          required
                          data-datepicker
                          ref="orderDateStRef"
                          v-model="data.biz1.search.searchDateSt"
                        />
                      </label>
                      <span class="tilde">~</span>
                      <label class="c-input-calender">
                        <input
                          type="text"
                          title="종료일"
                          readonly
                          required
                          data-datepicker
                          ref="orderDateEdRef"
                          v-model="data.biz1.search.searchDateEd"
                        />
                      </label>
                    </div>
                    <!-- // D : 달력 -->
                  </li>
                  <li v-for="(item, index) in searchPeriod" :key="index">
                    <div class="c-radio">
                      <input
                        type="radio"
                        :id="'raido1-' + (index + 1)"
                        name="raidogroup"
                        :value="item.value"
                        v-model="data.biz1.search.searchPeriod"
                        @change="dateCalculation(item.value)"
                      />
                      <label :for="'raido1-' + (index + 1)">{{
                        item.name
                      }}</label>
                    </div>
                  </li>
                </ul>
              </section>
              <section class="item-box" v-if="props.div === 'orderList'">
                <h3 class="c-title-level4">주문상태</h3>
                <ul class="c-check-field col2">
                  <li v-for="(item, index) in data.codes.code01" :key="index">
                    <div class="c-radio">
                      <input
                        type="radio"
                        :id="'raido2-' + index"
                        name="raidogroup2"
                        :value="item.cdVl"
                        v-model="data.biz1.search.orderStatusCd"
                      />
                      <label :for="'raido2-' + index">{{ item.cdNm }}</label>
                    </div>
                  </li>
                </ul>
              </section><section class="item-box" v-if="props.div === 'orderList'">
                <h3 class="c-title-level4">배송상태</h3>
                <ul class="c-check-field col2">
                  <li v-for="(item, index) in data.codes.code02" :key="index">
                    <div class="c-radio">
                      <input
                        type="radio"
                        :id="'raido3-' + index"
                        name="raidogroup3"
                        :value="item.cdVl"
                        v-model="data.biz1.search.selectedDlvCd"
                      />
                      <label :for="'raido3-' + index">{{ item.cdNm }}</label>
                    </div>
                  </li>
                </ul>
              </section>
            </div>

            <div class="dialog-footer only-mo">
              <div class="c-btn-area">
                <button
                  type="button"
                  class="c-button type-secondary"
                  @click="resetCmd('biz1#reset')"
                >
                  <span>초기화</span>
                </button>
                <button
                  type="button"
                  class="c-button type-primary"
                  @click="btnCmd('biz1#search')"
                >
                  <span>조회</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AbstractPop>
</template>
<script setup name="moDeepInqueryPop">
import {
  computed,
  defineEmits,
  onMounted,
  reactive,
  ref,
  defineProps,
  watch,
} from "vue";
import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";
const { isMobile } = cmUtil.useDeviceType();
import $ from "jquery";
import AbstractPop from "../common/AbstractPop.vue";

const props = defineProps({
  filter: {
    type: Object,
    required: true,
  },
  div: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["close", "search"]);

const orderDateStRef = ref(null);
const orderDateEdRef = ref(null);
const calSelected = ref(false);

const searchPeriod = ref([
  { name: "1주일", value: "week" },
  { name: "1개월", value: "month" },
  { name: "3개월", value: "three-month" },
  { name: "6개월", value: "half-year" },
]);
const todayDate = computed(() => {
  const now = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  return now.toLocaleDateString("en-CA", options);
});

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    token: "",
    isLogin: false,
    userLoginInfo: {},
    query: {},
    deviceType: isMobile.value ? "M" : "P",
    path: "",
  },
  codes: {
    code01: [], // 주문상태코드
    code02: [],
  },
  popup: { showInqueryPopup: false },
  // 주문내역 주문서
  biz1: {
    mode: "",
    search: {
      searchDateSt: props.filter.searchDateSt, // 시작 주문일자
      searchDateEd: props.filter.searchDateEd, // 끝 주문일자
      orderStatusCd: props.filter.orderStatusCd, // 주문상태코드
      selectedDlvCd : props.filter.selectedDlvCd, //배송상태
      searchQuery: props.filter.searchQuery, // 검색어
      searchPeriod: props.filter.searchPeriod,
      useYn: "Y",
      orderBy: "",
      resDateSt: "",
      resDateEd: "",
    },
    search_init: {}, // 검색 파라메터 초기값
    list: [], // 목록
    page: 0, // 현재 페이지
    limit: 20, // 목록 조회 행수
    totalCount: 0,
    totalPage: 0,
    loading: false,
    detail: [],
    cancelMsg: "",
    orderEmpInfo: {},
  },
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  await pageInitData();
  jqueryDatepicker();
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  mparm.push({ qId: "cmCode_code1", parm: { cdGrp: "ZTRANS_STATUS" } });
  mparm.push({ qId: "cmCode_code2", parm: { cdGrp: "DLV_MTHD_CD" } });
  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    return false;
  }
  const { cmCode_code1 } = res.data; // 주문상태코드
  const { cmCode_code2 } = res.data; // 배송방식코드

  data.page.token = cmUtil.getLocalStorage("token");
  data.page.isLogin = store.useAuthStore()?.user ? true : false;
  data.page.userLoginInfo = store.useAuthStore()?.user;
  data.codes.code01 = cmCode_code1;
  data.codes.code02 = cmCode_code2;

  const orderStatusCdAll = { cdNm: "전체", cdVl: "" };
  const selectedDlvCdAll = { cdNm: "전체", cdVl: "" };
  data.codes.code01.unshift(orderStatusCdAll);
  data.codes.code02.unshift(selectedDlvCdAll);
  calSelected.value = data.biz1.search.searchPeriod == "all" ? true : false;

  // ◼◼◼ 초기데이타 백업
  data.biz1.search_init = {
    searchDateSt: "",
    searchDateEd: "",
    orderStatusCd: "",
    selectedDlvCd: "",
    searchQuery: "",
    searchPeriod: "month",
    useYn: "Y",
    orderBy: "",
    resDateSt: "",
    resDateEd: "",
  };
}

/**********************
 * 리셋 모음
 *********************/
async function resetCmd(cmd = "", parms = {}) {
  if (cmd === "biz1#reset") {
    // ◼◼◼ biz1 초기화
    data.biz1.search = { ...data.biz1.search_init };
    dateCalculation("month");
  } else {
    alert(
      `[개발확인] resetCmd() cmd [${cmd}] 를 확인해주세요` +
        JSON.stringify(parms, null, " ")
    );
    return false;
  }
}

/**********************
 * 조회 모음
 *********************/
function btnCmd(cmd = "") {
  if (cmd === "biz1#search") {
    if (
      calculateDateDifference(
        data.biz1.search.searchDateSt,
        data.biz1.search.searchDateEd
      )
    ) {
      cmUtil.alert("조회기간은 최대 6개월입니다.\n날짜를 다시 선택해주세요.");
      return;
    }
    emit("search", data.biz1.search);
  }
}

// 검색 기간 계산
async function dateCalculation(period) {
  calSelected.value = false;
  const today = new Date();
  let resultDate = new Date(today);
  switch (period) {
    case "week":
      resultDate.setDate(today.getDate() - 6);
      break;
    case "month":
      resultDate.setDate(today.getDate() - 29);
      break;
    case "three-month":
      resultDate.setDate(today.getDate() - 89);
      break;
    case "half-year":
      resultDate.setDate(today.getDate() - 179);
      break;
    default:
      await cmUtil.alert("알 수 없는 기간입니다.");
      return null;
  }

  // YYYY-MM-DD 형식으로 변환
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  resultDate = resultDate.toLocaleDateString("en-CA", options);
  data.biz1.search.searchDateSt = resultDate;
  data.biz1.search.searchDateEd = todayDate.value;
}

const datePair = computed(() => [
  data.biz1.search.searchDateSt,
  data.biz1.search.searchDateEd,
]);

// 검색기간 시작일, 종료일 체크
watch(
  datePair,
  async ([newStartDate, newEndDate], [oldStartDate, oldEndDate]) => {
    const start = new Date(newStartDate);
    const end = new Date(newEndDate);
    if (end < start) {
      data.biz1.search.searchDateSt = oldStartDate;
      data.biz1.search.searchDateEd = oldEndDate;
      await cmUtil.alert(
        "종료일을 시작일보다 이전으로 설정할 수 없습니다.<br>다시 확인해주세요."
      );
    }
  }
);

// jquery 달력
function jqueryDatepicker() {
  if (orderDateStRef.value == null) return;
  $(orderDateStRef.value).datepicker({
    showOn: "both",
    buttonText: "달력",
    changeYear: true,
    changeMonth: true,
    showOtherMonths: true,
    selectOtherMonths: true,
    nextText: "다음 달",
    prevText: "이전 달",
    dateFormat: "yy-mm-dd",
    maxDate: 0,
    monthNamesShort: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    beforeShow: function (input, inst) {
      inst.dpDiv.addClass("order-calendar");
    },
    // 날짜 선택 후 콜백
    onSelect: function (dateText) {
      data.biz1.search.searchDateSt = dateText;
      data.biz1.search.searchPeriod = "all";
      calSelected.value = true;
    },
  });
  if (orderDateEdRef.value == null) return;
  $(orderDateEdRef.value).datepicker({
    showOn: "both",
    buttonText: "달력",
    changeYear: true,
    changeMonth: true,
    showOtherMonths: true,
    selectOtherMonths: true,
    nextText: "다음 달",
    prevText: "이전 달",
    dateFormat: "yy-mm-dd",
    maxDate: 0,
    monthNamesShort: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    beforeShow: function (input, inst) {
      inst.dpDiv.addClass("order-calendar");
    },
    // 날짜 선택 후 콜백
    onSelect: function (dateText) {
      data.biz1.search.searchDateEd = dateText;
      data.biz1.search.searchPeriod = "all";
      calSelected.value = true;
    },
  });
}

// 날짜 차이를 계산하는 함수
function calculateDateDifference(start, end) {
  const startDate = new Date(start);
  const endDate = new Date(end);

  const msInOneDay = 1000 * 60 * 60 * 24;
  const timeDifference = Math.abs(endDate - startDate);
  const dayDifference = timeDifference / msInOneDay;

  // 6개월(180일) 이상의 차이가 있는지 확인
  return dayDifference >= 180;
}
</script>
